export const SET_TABS = Symbol('dash/SET_TABS');

export const SET_ITEM_DATA = Symbol('dash/SET_ITEM_DATA');
export const SET_COPIED_ITEM_DATA = Symbol('dash/SET_COPIED_ITEM_DATA');

export const SET_CURRENT_TAB_DATA = Symbol('dash/SET_CURRENT_TAB_DATA');
export const UPDATE_CURRENT_TAB_DATA = Symbol('dash/UPDATE_CURRENT_TAB_DATA');
